<template>
  <div>
    <MemberLayout>
      <div class="container">
        <select class="form-control" @change="onSetChanged($event)">
          <option value="" disabled selected>請選擇商品套組</option>
          <option
            v-for="opt in getSetcodeOptions"
            :key="`setCodeOption${opt.value}`"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>
        <div>
          <div v-for="seq in productSeqList" :key="seq.sequenceId">
            <div :class="['card', 'mt-3']">
              <div class="card-header bg-primary text-white">
                {{ seq.title }}
              </div>
              <ul class="list-group list-group-flush">
                <li
                  v-for="(product, i) in seq.products"
                  :key="`seq${seq.sequenceId}product${i}`"
                  :class="[
                    'list-group-item',
                    {
                      'd-none':
                        seq.sequenceId != currentSequence && !product.isChecked,
                    },
                  ]"
                >
                  <div class="row">
                    <div class="col-4">
                      <img
                        :src="`http://fordays-backend-official.herokuapp.com/assets/product_images/${product.data.ICON}`"
                        alt=""
                        class="w-100"
                      />
                    </div>
                    <div class="col-8">
                      <h4 class="product-name">{{ product.data.NAME }}</h4>
                      <h5 class="product-price">
                        $ {{ product.data.UNITPRICE }} NTD x
                        {{ product.DEFAULTNET }}
                      </h5>
                    </div>
                    <div class="col-12 my-3">
                      <button
                        :class="[
                          'btn',
                          { 'btn-primary': !product.isChecked },
                          { 'btn-warning': product.isChecked },
                          'btn-block',
                        ]"
                        @click="
                          pressSelectProductBtn({
                            isSeqCurrentSeq: seq.sequenceId == currentSequence,
                            regularSet: seq.regularSet,
                            SEQUENCE: product.SEQUENCE,
                            itemIndex: i,
                            isSelect: !product.isChecked ? true : false,
                          })
                        "
                      >
                        <span v-if="!product.isChecked">選取品項</span>
                        <span v-if="product.isChecked">品項已選取</span>
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <h3>已選取商品金額： ${{ regularSummation() }}</h3>
          </div>
          <div v-if="nextBtnAvailable" class="my-3">
            <button class="btn btn-warning btn-block" @click="navigateToNext">
              下一步
            </button>
          </div>
        </div>
      </div>
      <Loading v-if="!isLoaded" />
    </MemberLayout>
  </div>
</template>
<script>
import moment from "moment";
import MemberLayout from "../../components/member/MemberLayout";
import Loading from "../../components/Loading";
import {
  getCurrentUser,
  getBusinessMonth,
  getUserRegularSellsets,
} from "../../api/fordaysHelpers";
export default {
  name: "RegularOrderScreen",
  components: {
    MemberLayout,
    Loading,
  },
  data() {
    return {
      regularSets: {},
      setcode: null,
      currentSequence: 1,
      isLoaded: false,
      cart: {
        SEQ: null,
        user: {},
        items: {},
        type: "regular",
        // 購買模式：(1=定期購買、2=加購)
        SALESTYPE: 1,
        updatedAt: new Date(),
        // 是否走完付款流程(可能成功與失敗)
        isFinishedPayment: false,
        // 付款流程完成於
        paymentFinishedAt: null,
        // 寫入Fordays是否有出錯
        fordaysJsellallinError: 0,
        // 作業系統
        deviceOS: window.navigator.platform,
        deviceOSVersion: window.navigator.appVersion,
        // 狀態
        // 'notPay' 還沒付款
        // 'payError' 付款失敗
        // '3DPayError' 3D付款失敗
        // 'paySuccess' 付款成功
        status: "notPay",
        // 3D Tappay錯誤物件
        errThreeDomain: {},
        // 是否可被公開取得(Secure Rule)
        isPublic: true,
      },
      nextBtnAvailable: false,
      productSeqList: [],
    };
  },
  computed: {
    getSetcodeOptions() {
      const vm = this;
      const sets = Object.keys(vm.regularSets);
      const options = [];
      sets.forEach(function (setcode) {
        const option = { label: `商品套組${setcode}`, value: setcode };
        options.push(option);
      });
      return options;
    },
  },
  methods: {
    navigateToNext() {
      const vm = this;
      const { cart } = vm;
      const newCart = cart;
      newCart.createdAt = new Date();
      newCart.updatedAt = newCart.createdAt;
      vm.isLoaded = false;
      // push 一定要有name才能帶 params
      vm.$router.push({
        name: "OrderSummationScreen",
        params: { cart: newCart },
      });
    },
    pressSelectProductBtn(obj) {
      const vm = this;
      const { regularSets, cart, setcode } = vm;
      const { regularSet, isSeqCurrentSeq } = obj;
      if (isSeqCurrentSeq) {
        if (obj.isSelect) {
          vm.onSequenceProductSelect(obj, regularSet);
        }
      } else {
        const newRegularSets = { ...regularSets };
        newRegularSets[setcode][obj.SEQUENCE][obj.itemIndex].isChecked = false;
        const newCart = { ...cart };
        delete cart.items[obj.SEQUENCE];
        vm.regularSets = newRegularSets;
        vm.currentSequence = obj.SEQUENCE;
        vm.cart = newCart;
        vm.nextBtnAvailable = false;
      }
      // if (obj.isSelect) {
      //   vm.onSequenceProductSelect(obj, regularSet);
      // }
    },
    onSequenceProductSelect(obj, rs) {
      const vm = this;
      const { cart } = vm;
      const SEQUENCE = obj.SEQUENCE;
      const index = obj.itemIndex;
      const regularSet = { ...rs };
      regularSet[SEQUENCE].forEach((product) => {
        product.isChecked = false;
      });
      const product = regularSet[SEQUENCE][index];

      // 設定選擇的數量(定期預設使用DEFAULTNET)
      product.amount = product.DEFAULTNET;
      product.isChecked = true;
      const newCart = { ...cart };
      newCart.items[SEQUENCE] = product;
      newCart.updatedAt = new Date();
      const seqsLen = Object.keys(regularSet).length;
      let nextSequence = obj.SEQUENCE + 1;
      if (Object.keys(newCart.items).length === seqsLen) {
        nextSequence = seqsLen + 1;
      }
      vm.currentSequence = nextSequence;
      vm.cart = newCart;
      if (nextSequence > seqsLen) {
        vm.nextBtnAvailable = true;
      }
    },
    onSetChanged($event) {
      const vm = this;
      const newSetcode = $event.target.value;
      if (!newSetcode) {
        return;
      }
      const newCart = { ...vm.cart };
      newCart.items = {};
      if (vm.setcode && vm.setcode !== newSetcode) {
        // FIXME: 此部分未完成參考RegularOrderScreen:232處理
        alert("切換商品套組將會清空目前已選擇的購物商品項目，請確認是否繼續");
        vm.setcode = newSetcode;
        vm.cart = newCart;
        vm.currentSequence = 1;
        vm.setUpSeqList();
      } else {
        vm.setcode = newSetcode;
        vm.cart = newCart;
        vm.currentSequence = 1;
        vm.setUpSeqList();
      }
    },
    setUpSeqList() {
      const vm = this;
      const { setcode, regularSets, currentSequence } = vm;
      console.log("regularSets", regularSets);
      const productSequences = regularSets[setcode]
        ? Object.keys(regularSets[setcode])
        : [];
      const productSeqList = productSequences.map((sequenceId) => {
        const regularSet = regularSets[setcode];
        const products = regularSet[sequenceId];
        const showCheckedOnly = sequenceId == currentSequence ? false : true;
        return {
          regularSet,
          sequenceId,
          title: `定期必選${sequenceId}`,
          products,
          showCheckedOnly,
        };
      });
      vm.productSeqList = productSeqList;
    },
    regularSummation() {
      const vm = this;
      const { cart } = vm;
      let regularSummation = 0;
      for (let x in cart.items) {
        regularSummation += cart.items[x].data.UNITPRICE * cart.items[x].amount;
      }
      return regularSummation;
    },
  },
  mounted() {
    const vm = this;
    async function fetchData() {
      const user = await getCurrentUser();
      if (user.ACT == 1) {
        vm.$router.push("/member/order-main");
        return;
      }
      const businessMonth = getBusinessMonth();
      const allSets = await getUserRegularSellsets(user, businessMonth);
      const newCart = { ...vm.cart };
      newCart.user = user;
      newCart.businessMonth = businessMonth;
      newCart.receptDate = moment().format("YYYYMMDD");
      newCart.SEQ = user.SEQ;
      newCart.uid = user.uid;
      vm.cart = newCart;
      vm.regularSets = allSets;
      vm.isLoaded = true;
    }
    fetchData();
  },
};
</script>
<style lang="scss" scoped>
</style>